module.exports = __webpack_public_path__ + "img/GB-WhatsApp-for-andriod.a357ed39.webp";